import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface DeleteIncomeFieldTypeParams {
  id: string;
}

const deleteIncomeFieldType: MutationFunction<
  boolean,
  DeleteIncomeFieldTypeParams
> = async ({ id }) => {
  if (isMockServices()) return await mock(true);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/income-field-types/${id}`,
    { method: 'DELETE' },
  );

  if (response.data) return response.data.success;
  throw new Error('Failed to delete income field type');
};

export default deleteIncomeFieldType;
